<template>
  <span>
    {{ spacer }}
    <BaseEllipseContent
      v-for="(author, index) in authors"
      :key="index"
      as="span"
      class="tw:inline tw:whitespace-normal tw:break-words"
      :class="{
        'tw:pr-1': index !== authors.length - 1,
      }"
      ><span
        :class="authorClass(author)"
        @click="loadJournalist(author, $event)"
        >{{ formatAuthor(author) }}</span
      ><span v-if="index !== authors.length - 1">{{ "," }}</span>
    </BaseEllipseContent>
  </span>
</template>

<script>
import { twMerge } from "tailwind-merge";

import { BaseEllipseContent } from "shared/components/base";
import { useSidebarOnMentionCard } from "shared/composables/useSidebarOnMentionCard";
import { capitalizeName, splitAuthors } from "shared/helpers/string";
import { useSideBarStore } from "shared/modules/SideBar/stores/useSideBarStore";
import { SocialMentionType } from "shared/types/mentions";

export default {
  name: "AuthorWidget",
  components: { BaseEllipseContent },
  props: {
    mention: {
      type: Object,
      required: true,
    },
    noSpacer: {
      type: Boolean,
    },
    disableClick: {
      type: Boolean,
    },
    formatAuthor: {
      type: Function,
      default: capitalizeName,
    },
    disableAuthorClickDefault: {
      type: Boolean,
    },
    class: {
      type: String,
      default: "",
    },
  },
  emits: ["author-click"],
  setup() {
    const sideBarStore = useSideBarStore();
    const { showSideBar, setSideBarContent } = sideBarStore;

    const { isInfluencerEnabled, selectInfluencer } = useSidebarOnMentionCard(
      {}
    );

    return {
      isInfluencerEnabled,
      showSideBar,
      setSideBarContent,
      selectInfluencer,
    };
  },
  computed: {
    isSocial() {
      return Object.values(SocialMentionType).includes(this.mention.type);
    },
    spacer() {
      return this.isSocial || this.noSpacer ? "" : "·";
    },
    authors() {
      if (!this.mention.author) return [];

      return splitAuthors(this.mention.author);
    },
    defaultAuthorClass() {
      const defaultClass = "tw:cursor-pointer tw:hover:text-denim-900";
      const baseClass = !this.disableClick ? defaultClass : "";

      return baseClass;
    },
  },
  methods: {
    authorClass(author) {
      const baseClass =
        this.isInfluencer(author) || !this.disableAuthorClickDefault
          ? this.defaultAuthorClass
          : "";

      return twMerge(baseClass, this.class);
    },
    isInfluencer(author) {
      return this.isInfluencerEnabled(author, this.mention.influencers);
    },
    loadJournalist(author, event) {
      if (this.disableClick) return;

      event.stopPropagation();

      const influencer = this.selectInfluencer(
        author,
        this.mention.influencers
      );

      if (influencer) {
        this.$emit("author-click", influencer);

        return;
      }

      if (this.disableAuthorClickDefault) return;

      this.authorClickedDefault(author);
    },
    authorClickedDefault(author) {
      if (this.$isDesktop) {
        this.loadSideBar(author);
      } else if (this.$isMobile) {
        this.$safeRouterPush({
          name: "journalist-view",
          query: { author },
          state: {
            mention: JSON.stringify(this.mention),
          },
        }).catch(() => {});
      }
    },
    loadSideBar(author) {
      this.setSideBarContent({
        title: "",
        component: "JournalistSideBar",
        data: { author, mention: this.mention },
      });

      this.showSideBar();
    },
  },
};
</script>
